var component = require('../../../lib/js/component.js');

function HeroWide() {
    this.initialize = function (element, options) {
        var _this = this;
        var isAutoplay = false;
        var carouselRotationInterval = _this.$element.find('.owl-carousel').attr('data-carousel-rotation-interval');
        if (carouselRotationInterval > 0) {
            isAutoplay = true;
        }
        
        // Find carousels within this hero-wide component
        var $carousels = _this.$element.find('.owl-carousel');

        // pause autoplaying carousels on focus for accessibility
        if (isAutoplay) {
            $carousels.on('focusin', function() {
                $(this).trigger('stop.owl.autoplay');
            });
    
            $carousels.on('focusout', function() {
                $(this).trigger('play.owl.autoplay');
            });
        }

        if ($carousels.length) {
            // Listen for owl carousel initialization event
            $carousels.on('initialized.owl.carousel', function() {
                _this.addAriaLabelsToDots();
                _this.updateAriaCurrentOnDots();
            });
            
            // Listen for carousel change events to update aria-current
            $carousels.on('changed.owl.carousel', function() {
                _this.updateAriaCurrentOnDots();
            });
            
            // Also try to add labels immediately in case carousel is already initialized
            _this.addAriaLabelsToDots();
            _this.updateAriaCurrentOnDots();
        }
    }

    /**
     * Add aria-labels to carousel navigation dots for accessibility
     * Each dot will have a descriptive label like "Go to slide 1", "Go to slide 2", etc.
     */
    this.addAriaLabelsToDots = function () {
        var _this = this;

        // There are 2 carousels in this component, one mobile and one desktop
        var $carousels = _this.$element.find('.Carousel-v1');   

        $carousels.each(function() {
            var $carousel = $(this);

            var $dots = $carousel.find('.owl-dot');
            $dots.each(function (index) {
                var slideNumber = index + 1;
                $(this).attr('aria-label', 'Go to slide ' + slideNumber);
                $(this).attr('role', 'button');
            });
        });
    }

    /**
     * Update aria-current attribute on carousel dots
     * Sets aria-current="true" on the active dot and removes it from inactive dots
     */
    this.updateAriaCurrentOnDots = function () {
        var _this = this;

        // There are 2 carousels in this component, one mobile and one desktop
        var $carousels = _this.$element.find('.Carousel-v1');   

        $carousels.each(function() {
            var $carousel = $(this);

            // Only update visible carousel
            if (!$carousel.is(':visible')) return; 

            var $dots = $carousel.find('.owl-dot');
            $dots.each(function () {
                var $dot = $(this);
                if ($dot.hasClass('active')) {
                    $dot.attr('aria-current', 'true');
                } else {
                    $dot.removeAttr('aria-current');
                }
            });
        });
    }
}

module.exports = component(HeroWide);
